import { twMerge } from "tailwind-merge";
import { ReactComponent as ChevronDownIcon } from "../../assets/icons/chevron-down.svg";


export function SelectInput({
  value,
  onChange,
  options,
  className = "",
  // Optional: a select that always carries a value has nothing to placehold,
  // and the option below would sit in its list as a dead first row.
  placeholder = "",
  containerClassName = "",
  disabled = false,
}) {
  return (
    <div className={twMerge("relative inline-block", containerClassName)}>
      <select
        className={twMerge(
          "border w-full border-[#E9E9E9] rounded px-2 py-1 pr-8 !outline-none appearance-none",
          !value && "text-[#7C7C7C]",
          disabled && "cursor-not-allowed !text-gray-402 !border-gray4",
          className
        )}
        onChange={onChange}
        value={value}
        disabled={disabled}
      >
        {placeholder ? (
          <option className="text-[#7C7C7C]" value="" disabled>
            {placeholder}
          </option>
        ) : null}
        {options.map((option) => (
          <option key={`${option.value}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDownIcon className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none [&_path]:stroke-black" />
    </div>
  );
}
